import { Component } from 'react';

/**
 * Without this a single render-time throw leaves the user on a blank page with
 * no way back. Class component because React has no hook equivalent.
 */
export class ErrorBoundary extends Component {
  state = { error: null };

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('Unhandled render error:', error, info);
  }

  handleReload = () => {
    window.location.assign('/');
  };

  render() {
    const { error } = this.state;
    if (!error) return this.props.children;

    return (
      <div className="flex min-h-screen flex-col items-center justify-center gap-3 p-6 text-center text-fg-muted">
        <h2 className="text-2xl font-semibold text-fg">Something broke</h2>
        <p className="max-w-lg text-sm">
          The dashboard hit an unexpected error and could not finish rendering.
        </p>
        {import.meta.env.DEV && (
          <pre className="max-w-[90vw] overflow-x-auto text-left text-xs text-danger">
            {error.stack || String(error)}
          </pre>
        )}
        <button
          type="button"
          className="mt-2 rounded-sm border border-line bg-surface-raised px-[18px] py-2.5 font-semibold text-fg transition-colors hover:border-accent"
          onClick={this.handleReload}
        >
          Reload
        </button>
      </div>
    );
  }
}
